import React from "react";
import VideoUpgrade from "../../components/videoUpgrade/VideoUpgrade";

const UpgradeDashboard = () => {
  return <VideoUpgrade />; 
};

export default UpgradeDashboard;
